// Safe storage helpers to avoid SSR/privacy-mode errors
// Centralize all localStorage/sessionStorage access here.

export function getLocalStorageSafe(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    const ls = window.localStorage;
    const k = '__ls_test__';
    ls.setItem(k, '1');
    ls.removeItem(k);
    return ls;
  } catch {
    return null;
  }
}

export function getSessionStorageSafe(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    const ss = window.sessionStorage;
    const k = '__ss_test__';
    ss.setItem(k, '1');
    ss.removeItem(k);
    return ss;
  } catch {
    return null;
  }
}

export const localStore = {
  get(key: string): string | null {
    try {
      return getLocalStorageSafe()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      getLocalStorageSafe()?.setItem(key, value);
    } catch {
      // ignore
    }
  },
  remove(key: string): void {
    try {
      getLocalStorageSafe()?.removeItem(key);
    } catch {
      // ignore
    }
  },
  getJSON<T>(key: string, fallback: T): T {
    const raw = this.get(key);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  setJSON(key: string, value: unknown): void {
    try {
      this.set(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  },
};

export const sessionStore = {
  get(key: string): string | null {
    try {
      return getSessionStorageSafe()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      getSessionStorageSafe()?.setItem(key, value);
    } catch {
      // ignore
    }
  },
  remove(key: string): void {
    try {
      getSessionStorageSafe()?.removeItem(key);
    } catch {
      // ignore
    }
  },
  getJSON<T>(key: string, fallback: T): T {
    const raw = this.get(key);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  setJSON(key: string, value: unknown): void {
    try {
      this.set(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  },
};
